import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BreathePause from "@/components/BreathePause";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ServicesPage from "@/pages/Services";
import PricingPage from "@/pages/Pricing";
import BookingPage from "@/pages/Booking";
import ContactPage from "@/pages/Contact";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--cc-bg)]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <BreathePause />
      <Footer />
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="cc-page">
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <AppRoutes />
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
